module.exports = __webpack_public_path__ + "img/profile.c7c76e2d.svg";